import type { TrainingEvent } from "../utilities";

export interface TrainingAnalyticRequest {
    workerActivityName: string | undefined;
    taskSid: string;
    eventType: TrainingEvent;
}

export interface CancelTrainingPayload {
    action: string;
    reason: string;
}
